module.exports = __webpack_public_path__ + "img/share_fb.1390555e.png";